import React from 'react';
import { Box, Button, FormControlLabel, Accordion, AccordionSummary, AccordionDetails, Switch, Typography } from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { makeStyles } from '@material-ui/core/styles';
import { useAdrBeta } from './BetaProvider';

const useStyles = makeStyles(theme => ({
  container: {
    '&&': { borderRadius: 16, border: '1px solid #e3e9f0', boxShadow: '0 3px 14px rgba(30, 50, 80, 0.04)', margin: 0 },
    '&:before': { display: 'none' },
  },
  summary: { padding: theme.spacing(1, 3), minHeight: 80 },
  details: { display: 'block', padding: theme.spacing(0, 3, 3) },
  feature: { padding: theme.spacing(2, 3), borderRadius: 12, background: '#f6f9fd', border: '1px solid #e9eff6' },
}));

export default function BetaSettings() {
  const beta = useAdrBeta();
  const classes = useStyles();
  return <Accordion className={classes.container} elevation={0}>
    <AccordionSummary className={classes.summary} expandIcon={<ExpandMoreIcon />} aria-controls="beta-features-content" id="beta-features-header">
      <Box>
        <Typography variant="h6" style={{ fontSize: 17, fontWeight: 600, color: '#243247' }}>Beta features</Typography>
        <Typography variant="body2" color="textSecondary">Explore optional features that are still in development.</Typography>
      </Box>
    </AccordionSummary>
    <AccordionDetails className={classes.details}><Box className={classes.feature}>
    <FormControlLabel label="Enable Adverse Reporting beta" control={<Switch
      color="primary" checked={beta.adrBetaOptIn} disabled={beta.loading || beta.saving || Boolean(beta.error)}
      onChange={event => beta.update(event.target.checked)}
    />} />
    <Typography variant="body2" color="textSecondary" style={{ lineHeight: 1.7, marginTop: 4 }}>Create adverse reaction reports and download XML for submission. Your reports are shared within your company. Turning this off keeps your saved reports.</Typography>
    {beta.loading && <Typography role="status">Loading your preference…</Typography>}
    {beta.saving && <Typography role="status">Saving your preference…</Typography>}
    {!beta.loading && !beta.error && beta.adrBetaOptIn && !beta.adrBetaEnabled && <Typography role="status">The beta is temporarily unavailable. Your opt-in is saved.</Typography>}
    {beta.error && <Box role="alert"><Typography color="error">{beta.error}</Typography><Button onClick={beta.refresh}>Retry beta settings</Button></Box>}
  </Box></AccordionDetails></Accordion>;
}
